import { Component, Prop } from 'vue-property-decorator'
import { TableList } from '@src/components/table-list/table-list'
import { CreateElement } from '@src/vue'
import { ListHeader } from '@src/components/table-list/header'
import { ListBody } from '@src/components/table-list/body'
import { Pagination } from '@src/elements/pagination/pagination'

@Component
export class CustomPaginationTableList extends TableList {

  @Prop({ required: true })
  noOfPages: number

  // tslint:disable-next-line:no-empty
  @Prop({ required: false, default: { label: '', onClickCallback: () => { } } })
  options: { label: string, onClickCallback: (item) => void }[]

  render (h: CreateElement) {
    return <div class='table-list'>

      {this.header ? <ListHeader columns={this.header} /> : null}

      <ListBody items={this.paginate(this.order(this.items))} cells={this.cells} options={this.options} />

      <Pagination resizePage={this.resizePage}
                  changePage={this.changePage}
                  currentPage={this.currentPage}
                  pageSize={this.pageSize}
                  total={this.noOfPages * this.pageSize} />
    </div>
  }

  protected paginate (items) {
    return items
  }
}
